import Main from './ui/Main';
MOCK // npm run pack 会自动启用 mock , npm run min 会自动关掉 mock, 如果想直接关闭 mock 可以注释掉本行

let main = new Main();

export default main;